/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlIPMetadataPrivacy
 */
export interface ControlIPMetadataPrivacy {
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPMetadataPrivacy
     */
    hosting: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIPMetadataPrivacy
     */
    lastSeen?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlIPMetadataPrivacy
     */
    percentDaysSeen?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPMetadataPrivacy
     */
    proxy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPMetadataPrivacy
     */
    relay: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPMetadataPrivacy
     */
    residentialProxy?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIPMetadataPrivacy
     */
    service: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPMetadataPrivacy
     */
    tor: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIPMetadataPrivacy
     */
    vpn: boolean;
}

/**
 * Check if a given object implements the ControlIPMetadataPrivacy interface.
 */
export function instanceOfControlIPMetadataPrivacy(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hosting" in value;
    isInstance = isInstance && "proxy" in value;
    isInstance = isInstance && "relay" in value;
    isInstance = isInstance && "service" in value;
    isInstance = isInstance && "tor" in value;
    isInstance = isInstance && "vpn" in value;

    return isInstance;
}

export function ControlIPMetadataPrivacyFromJSON(json: any): ControlIPMetadataPrivacy {
    return ControlIPMetadataPrivacyFromJSONTyped(json, false);
}

export function ControlIPMetadataPrivacyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIPMetadataPrivacy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hosting': json['hosting'],
        'lastSeen': !exists(json, 'lastSeen') ? undefined : json['lastSeen'],
        'percentDaysSeen': !exists(json, 'percentDaysSeen') ? undefined : json['percentDaysSeen'],
        'proxy': json['proxy'],
        'relay': json['relay'],
        'residentialProxy': !exists(json, 'residentialProxy') ? undefined : json['residentialProxy'],
        'service': json['service'],
        'tor': json['tor'],
        'vpn': json['vpn'],
    };
}

export function ControlIPMetadataPrivacyToJSON(value?: ControlIPMetadataPrivacy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hosting': value.hosting,
        'lastSeen': value.lastSeen,
        'percentDaysSeen': value.percentDaysSeen,
        'proxy': value.proxy,
        'relay': value.relay,
        'residentialProxy': value.residentialProxy,
        'service': value.service,
        'tor': value.tor,
        'vpn': value.vpn,
    };
}

